import { render, staticRenderFns } from "./PlusoneGiftIcon.vue?vue&type=template&id=32cf6707&"
import script from "./PlusoneGiftIcon.vue?vue&type=script&lang=js&"
export * from "./PlusoneGiftIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports